import { createAction } from '@reduxjs/toolkit';
import { ProjectWithMapView } from '../types';

/* Action Types */
enum ActionTypes {
	UPDATE_MAP_BOUNDS = '@@mondriaan/MAP/UPDATE_BOUNDS',
}

export const updateMapBounds = createAction<ProjectWithMapView>(ActionTypes.UPDATE_MAP_BOUNDS);
